import { IsDateString, IsOptional } from 'class-validator';

/**
 * Shared query params for the DAHT bulk CSV export endpoints.
 */
export class DAHTExportQueryDto {
  /**
   * When provided, only records for participants enrolled (DAHT user-details
   * `created`) on or after this date are exported. ISO 8601 date string
   * (e.g. `2026-08-12`); the value is compared against a timestamp column.
   */
  @IsOptional()
  @IsDateString()
  fromEnrolledDate?: string;
}
